<ul id="accordion" class="accordion">
  <li *ngFor="let menu of menus; let i = index" [class.active]="menu.active">
    <div class="menu" (click)="disabletoggle(i)" *ngIf="!declined">
      <!-- <i [class]="menu.iconClass"></i> -->
      {{ menu.name }}
      <i class="fa fa-sort-desc" *ngIf="!bound"></i>
    </div>
    <div class="menu" (click)="disabletoggle(i)" *ngIf="declined">
      Declined
    </div>
    <ul
      class="submenu"
      #submenu
      [style.height.px]="menu.active ? submenu.scrollHeight : 0"
    >
      <li *ngFor="let submenu of menu?.submenu">
        <a
          *ngIf="bound"
          (click)="getName(submenu.name)"
          [class.selected]="clicked == submenu.name"
          >{{ submenu.name }}</a
        >
        <a
          *ngIf="declined"
          (click)="getName(submenu.name)"
          [class.selected]="clicked == submenu.name"
          >{{ submenu.name }}</a
        >
        <a
          *ngIf="additional"
          [routerLink]="submenu.url"
          [class.disabled]="disableAdditionalMenu()"
          [class.selected]="currentUrl == submenu.url"
          >{{ submenu.name }}</a
        >
        <!-- <a
          *ngIf="!bound && isUCMLink(submenu.url)"
          (click)="ucmFormRedirect(submenu.url)"
          [class.selected]="clickedUCMPage == submenu.url"
          >{{ submenu.name }}</a
        > -->
        <a
          *ngIf="!bound && !additional && !declined"
          [routerLink]="submenu.url"
          [class.disabled]="allSteps && !allSteps[submenu.url]"
          [class.selected]="currentUrl == submenu.url"
          (click)="validateBeforeNavigate()"
          >{{ submenu.name }}</a
        >
      </li>
    </ul>
  </li>
</ul>
